import { enUS, srRS } from '@mui/material/locale';
import enIcon from '@assets/lang/eng_flag.png';
import srIcon from '@assets/lang/srb_flag.png';

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: enIcon,
  },
  {
    label: 'Serbian',
    value: 'sr',
    systemValue: srRS,
    icon: srIcon,
  },
];

export const defaultLang: (typeof allLangs)[0] = localStorage.getItem('i18nextLng')
  ? (allLangs.find(
      (lang) => lang.value === localStorage.getItem('i18nextLng')
    ) as (typeof allLangs)[0])
  : allLangs[0];
